// Keep the Control token inside the configured API origin/path, including when a
// caller overrides Axios baseURL or supplies an absolute URL.
export function controlApiTarget(requestUri, apiUri, pageUri) {
  try {
    const api = new URL(apiUri, pageUri);
    const request = new URL(requestUri, pageUri);
    const prefix = api.pathname.replace(/\/$/, "");
    return request.origin === api.origin &&
      (request.pathname === prefix || request.pathname.startsWith(prefix + "/"));
  } catch (_) {
    return false;
  }
}

export function validControlCsrf(token) {
  return typeof token === "string" && /^[0-9a-f]{64}\.[0-9a-f]{64}$/.test(token);
}

export function controlCsrfHeader(method, requestUri, apiUri, pageUri, cookieText, cachedToken) {
  if (!["post", "put", "patch", "delete"].includes((method || "get").toLowerCase()) ||
      !controlApiTarget(requestUri, apiUri, pageUri)) return null;
  // Authenticated API JSON supplies the token when the API cookie lives on a
  // different host. Keep it in memory, never in persistent browser storage.
  const sameOrigin = new URL(apiUri, pageUri).origin === new URL(pageUri).origin;
  if (!sameOrigin) return validControlCsrf(cachedToken) ? cachedToken : null;
  try {
    const cookie = (cookieText || "").split(";").map((part) => part.trim())
      .find((part) => part.startsWith("__Host-control_csrf="));
    if (!cookie) return validControlCsrf(cachedToken) ? cachedToken : null;
    const value = decodeURIComponent(cookie.slice("__Host-control_csrf=".length));
    return validControlCsrf(value) ? value : null;
  } catch (_) {
    return null;
  }
}
